import React from "react";
import { NextPage } from "next";
import { Container } from "@material-ui/core";
import { createGetServerSideProps, StaticPageProps } from "evcharging/app";
import { I18nPage } from "i18n/types/pages.enum";
import Term from "containers/common/sections/terms";
import { Page } from "containers/common/sections/layout";

const Terms: NextPage<StaticPageProps> = ({page}) => {
  return (
    <Page title={page.meta_title} description={page.meta_description} locales={page.locales}>
      <Container>
        <Term />
      </Container>
    </Page>
  );
};

export const getServerSideProps = createGetServerSideProps(undefined, undefined, [I18nPage.Terms]);

export default Terms;
